import { CheckNotes, InspectionCase } from '../inspection-cases';
import { Inspection } from '../inspection.dto';
import { AerosolInstallation } from './aerosol-installation.dto';
import { Aerosol } from './aerosol.dto';
import { InstallationRequirements } from './installation-requirements.dto';
import { MarkupRequirements } from './markup-requirements.dto';
import { ShutdownComponents } from './shutdown-components.dto';

export class AerosolAreaDto extends InspectionCase {
  aerosol?: Aerosol;
  shutdownComponents?: ShutdownComponents;
  installationRequirements?: InstallationRequirements;
  markupRequirements?: MarkupRequirements;
  aerosolInstallation?: AerosolInstallation;
}

export class AerosolArea extends AerosolAreaDto implements Inspection {
  constructor(
    data: AerosolAreaDto = {
      title: '',
      isApplicable: true
    }
  ) {
    super(data);

    this.aerosol = new Aerosol(data.aerosol);
    this.shutdownComponents = new ShutdownComponents(data.shutdownComponents);
    this.installationRequirements = new InstallationRequirements(
      data.installationRequirements
    );
    this.markupRequirements = new MarkupRequirements(data.markupRequirements);
    this.aerosolInstallation = new AerosolInstallation(
      data.aerosolInstallation
    );
  }

  setInspectionStatus(): void {
    this.aerosol.setInspectionStatus();
    this.shutdownComponents.setInspectionStatus();
    this.installationRequirements.setInspectionStatus();
    this.markupRequirements.setInspectionStatus();
    this.aerosolInstallation.setInspectionStatus();

    this.isPassed =
      this.aerosol.isPassed &&
      this.shutdownComponents.isPassed &&
      this.installationRequirements.isPassed &&
      this.markupRequirements.isPassed &&
      this.aerosolInstallation.isPassed;
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.aerosol.getNotes(),
      ...this.shutdownComponents.getNotes(),
      ...this.installationRequirements.getNotes(),
      ...this.markupRequirements.getNotes(),
      ...this.aerosolInstallation.getNotes()
    ];
  }

  setAsApplicable?(): void {
    this.isApplicable = true;
    this.aerosol.setAsApplicable();
    this.shutdownComponents.setAsApplicable();
    this.installationRequirements.setAsApplicable();
    this.markupRequirements.setAsApplicable();
    this.aerosolInstallation.setAsApplicable();
  }
}
